import $ from 'cash-dom'

export default class AuthorSlider {
  constructor({ $container }) {
    this.$container = $container
    this.position = 0

    this.constructElements()

    this.constructEvents()

    this.doChangeHeight()
  }

  static init() {
    const $containers = $(AuthorSlider.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new AuthorSlider({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$item = this.$container.find(AuthorSlider.selectors.item)
    this.$track = this.$container.find(AuthorSlider.selectors.track)
  }

  constructEvents() {
    $(window)
      .on('resize', (e) => this.handleResize({ e }))

    this.$container
      .on('click', AuthorSlider.selectors.next, (e) => this.handleClickNext({ e }))
      .on('click', AuthorSlider.selectors.prev, (e) => this.handleClickPrev({ e }))
  }

  doChangeHeight() {
    this.$track.css({ height: `${this.getItemHeight()}px` })
  }

  doExitLeft({ $item }) {
    $item
      .addClass(AuthorSlider.classes.itemExitLeft)
      .removeClass(AuthorSlider.classes.itemEnter)
  }

  doExitRight({ $item }) {
    $item
      .addClass(AuthorSlider.classes.itemExitRight)
      .removeClass(AuthorSlider.classes.itemEnter)
  }

  doNext() {
    this.doExitLeft({ $item: this.$item.eq(this.position) })

    if (this.position === this.$item.length - 1) {
      this.position = 0
    } else {
      this.position++
    }

    this.doSlideNext()
  }

  doPrev() {
    this.doExitRight({ $item: this.$item.eq(this.position) })

    if (this.position === 0) {
      this.position = this.$item.length - 1
    } else {
      this.position--
    }

    this.doSlidePrev()
  }

  doSlideNext() {
    this.doChangeHeight()

    const $nextItem = this.$item.eq(this.position)

    $nextItem
      .removeClass(`${AuthorSlider.classes.itemExitLeft} ${AuthorSlider.classes.itemExitRight} ${AuthorSlider.classes.itemStageLeft}`)
      .addClass(AuthorSlider.classes.itemStageRight)

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        $nextItem.addClass(AuthorSlider.classes.itemEnter)
      })
    })
  }

  doSlidePrev() {
    this.doChangeHeight()

    const $prevItem = this.$item.eq(this.position)

    $prevItem
      .removeClass(`${AuthorSlider.classes.itemExitLeft} ${AuthorSlider.classes.itemExitRight} ${AuthorSlider.classes.itemStageLeft} ${AuthorSlider.classes.itemStageRight}`)
      .addClass(AuthorSlider.classes.itemStageLeft)

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        $prevItem.addClass(AuthorSlider.classes.itemEnter)
      })
    })
  }

  getItemHeight() {
    return this.$item.eq(this.position).height()
  }

  handleClickNext({ e }) {
    e.preventDefault()

    this.doNext()
  }

  handleClickPrev({ e }) {
    e.preventDefault()

    this.doPrev()
  }

  handleResize({ e }) {
    this.doChangeHeight()
  }
}

AuthorSlider.selectors = {
  container: '.js-author-slider',
  track: '.js-author-slider-track',
  item: '.js-author-slider-item',
  prev: '.js-author-slider-prev',
  next: '.js-author-slider-next',
}

AuthorSlider.classes = {
  itemEnter: 'o-author-slider__slider-item--enter',
  itemExitLeft: 'o-author-slider__slider-item--exit-left',
  itemExitRight: 'o-author-slider__slider-item--exit-right',
  itemStageLeft: 'o-author-slider__slider-item--stage-left',
  itemStageRight: 'o-author-slider__slider-item--stage-right',
}
